import { NessHardCodingConstantS } from '../Constant/module/NessHardCodingConstantS.js';

export const filterReservingProducts = () => {
  const now = new Date();
  return NessHardCodingConstantS.RESERVE_PRODUCTS.filter((p) => {
    return p.reserve_date > now;
  });
};
